import { render } from "./SmallPage.vue?vue&type=template&id=06c4128d&scoped=true&ts=true"
import script from "./SmallPage.vue?vue&type=script&lang=ts"
export * from "./SmallPage.vue?vue&type=script&lang=ts"

import "./SmallPage.vue?vue&type=style&index=0&id=06c4128d&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c4128d"]])

export default __exports__